module.exports = __webpack_public_path__ + "static/media/tandcc.a1e2ffda.png";